/*
* mutations.js
*
* Description: Holds global Mutations (for store).
*
* This file is part of: "http://apps.sundair.com/", "SunCrew2 - Flights"
* Copyright ,2020 Sundair GmbH
* Contact: http://www.sundair.com/
* @author Christian Arp <christian.arp@sundair.com>
* @author Learek <michael.broeker@sundair.com>
* @author Phillip Alsleben <phillip.alsleben@sundair.com>
*
*/
// demo
export const updateValue = (state, payload) => {
    state.value = payload;
};
